var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDownSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15244 7.60953C5.62099 8.13016 6.38193 8.13016 6.85048 7.60953L11.6485 2.27828C11.9933 1.89509 12.0945 1.32448 11.9071 0.824678C11.7197 0.324873 11.2849 0 10.7976 0L1.20159 0.00416529C0.718038 0.00416529 0.279471 0.329039 0.0920492 0.828843C-0.0953726 1.32865 0.00958363 1.89926 0.350691 2.28244L5.14869 7.61369L5.15244 7.60953Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownSolid);
export default __webpack_public_path__ + "static/media/caret-down-solid.0a4a18defdbffd3a1244ae088bce5c0f.svg";
export { ForwardRef as ReactComponent };